/**
 * The default text decoration for a tooltip trigger.
 * Useful if you're building your own or need to apply it to a specific nested text element.
 */
export const TOOLTIP_TRIGGER_DECORATION_CLASSNAME =
	'underline decoration-dotted underline-offset-[20%] decoration-[10%] decoration-text-secondary cursor-help';

export const TOOLTIP_CONTENT_CLASSNAME =
	'max-w-[300px] bg-tooltip-bg rounded-sm p-md typo-b4 text-text-default';
